/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Comment extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Comment;


// WEBPACK FOOTER //
// ./src/routes/comment/index.js